<div [ngClass]="dividerClasses" [ngStyle]="dividerStyles" role="separator" [attr.aria-orientation]="orientation"></div>
